
  import { mapState } from 'vuex'
  import ProtocolNav from '@/components/about/ai-protocol-nav.vue'

  export default {
    //  隐私政策页面
    name: 'AIYSZC',
    components: {
      ProtocolNav,
    },
    layout: 'template-page',
    fetchOnServer: false,
    fetch() {
      this.$store.commit('setHightLightHeader', { show: false })
      this.$store.commit('setFooterInfo', { show: false })
      const body = document.querySelector('body')
      body.style.display = 'block'
    },
    head() {
      return {
        title: '隐私政策_问卷网',
        scripts: [{}],
      }
    },
    computed: {
      ...mapState(['isMobile', 'innerWidth', 'clientScrollWidth']),
    },
    mounted() {
      window.onload = () => {
        const { innerWidth } = this
        this.handleHeaderShow(innerWidth > 640)
      }
    },
    methods: {
      // 跳转路由
      jump(url, query) {
        this.$href(url, query)
      },
      handleHeaderShow(val) {
        this.$store.commit('setHightLightHeader', { show: val })
        this.$store.commit('setFooterInfo', { show: val })
      },
    },
  }
